import { useSyncExternalStore } from 'react';

import type { AppSearchProvider } from './types';

let providers: readonly AppSearchProvider[] = [];
const listeners = new Set<() => void>();

const emit = () => {
  listeners.forEach((listener) => listener());
};

export const searchRegistry = {
  register(provider: AppSearchProvider) {
    providers = [
      ...providers.filter((item) => item.id !== provider.id),
      provider,
    ];
    emit();

    return () => {
      searchRegistry.unregister(provider.id);
    };
  },

  unregister(id: string) {
    const next = providers.filter((item) => item.id !== id);
    if (next.length === providers.length) {
      return;
    }

    providers = next;
    emit();
  },

  getProviders() {
    return providers;
  },

  clear() {
    if (providers.length === 0) {
      return;
    }

    providers = [];
    emit();
  },

  subscribe(listener: () => void) {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
};

export const useSearchProviders = () =>
  useSyncExternalStore(
    searchRegistry.subscribe,
    searchRegistry.getProviders,
    searchRegistry.getProviders,
  );